class TierTable extends HTMLElement {
  constructor() {
    super()

    // tiers
    this.navItems = this.querySelectorAll('.mobile-table-nav__item')
    this.targets = this.querySelectorAll('.tier-table-block--target')
    this.headers = this.querySelectorAll('.tier-table-block--heading')
    this.note = this.querySelector('.tier-note')

    this.tier1 = this.querySelectorAll('.mobile-table-nav__item--tier-1')
    this.tier2 = this.querySelectorAll('.mobile-table-nav__item--tier-1')
    this.tier3 = this.querySelectorAll('.mobile-table-nav__item--tier-1')
    this.tier4 = this.querySelectorAll('.mobile-table-nav__item--tier-1')
    this.tier5 = this.querySelectorAll('.mobile-table-nav__item--tier-1')
    this.initialiseTierTable()

  }

  initialiseTierTable() {

    const navItems = this.navItems
    const targets = this.targets
    const headers = this.headers
    const note = this.note

    navItems.forEach((item) => {
      item.addEventListener('click', (e) => {

        // remove all active classes
        navItems.forEach((item) => {
          item.classList.remove('active')

        })

        // add active class to clicked
        e.target.classList.add('active')

        // get attribute
        const number = e.target.getAttribute('data-index')
        let newMsg
        // populate note
        if (number == 1) {
          newMsg = `Tier 4`
        }
        if (number == 2) {
          newMsg = `Tier 3`
        }
        if (number == 3) {
          newMsg = `Tier 2`
        }
        if (number == 4) {
          newMsg = `Tier 1`
        }
        if (number == 5) {
          newMsg = `Black Ops`
        }

        note.innerHTML = `<h2>${newMsg}</h2>`


        // update table
        const tabIndex = e.target.getAttribute('data-index')
        targets.forEach((target) => {
          const targetIndex = target.getAttribute('data-index')
          target.classList.add('hide')

          if (targetIndex == tabIndex) {
            target.classList.remove('hide')
            target.classList.add('show')
          } else {
            target.classList.add('hide')
            target.classList.remove('show')
          }
        })

        // update headers.. 
        // headers.forEach((target) => {
        //     const targetIndex = target.getAttribute('data-index')
        //     target.classList.add('hide')

        //     if (targetIndex == tabIndex) {
        //         target.classList.remove('hide')
        //         target.classList.add('show')
        //     } else {
        //         target.classList.add('hide')
        //         target.classList.remove('show')
        //     }
        // })

      })
    })
  }
}

customElements.define('tier-table', TierTable)